import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CONFIG from "../../config";
import { useAuth } from "../../context/AuthProvider";
import "../../Styles/doctorlist.css"
import { usePatient } from "../../context/PatientContext";

const AddDoctor = () => {
  const [formData, setFormData] = useState({
    MANDALI_FULL_NAME: "",
    MANDALI_MOB_NO: "",
    MANDALI_PASSWORD: "",
    CONFIRM_PASSWORD: "",
    MANDALI_ROLE: 2,
    CLINIC_IDS: [] // ✅ array for multiple clinics
  });
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const {verifyTokenAndRedirect}= useAuth();
  const [clinics, setClinics] = useState([]); // State for clinic dropdown
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;
  const token = localStorage.getItem("authToken"); // or from context
  const {doctorInfo} = usePatient();

  // Fetch all clinics for the dropdown
  useEffect(() => {
    // axios
    //   .get(`${baseURL}/doctors/clinics`)
    verifyTokenAndRedirect();
    axios.get(`${baseURL}/doctors/clinics`, {
      headers: {
        Authorization: `Bearer ${token}`,        // 🔐 JWT Token
        doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
        clinicId: doctorInfo.CLINIC_ID,
        roleId: doctorInfo.MANDALI_ROLE
      }
    }) 

      .then((res) => setClinics(res.data))
      .catch((error) => console.error("Error fetching clinics:", error));
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form data to the backend
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate password and confirm password
    if (formData.MANDALI_PASSWORD !== formData.CONFIRM_PASSWORD) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const { CONFIRM_PASSWORD, ...dataToSend } = formData; // Remove confirm password field
      axios.post(`${baseURL}/doctors/add`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,        // 🔐 JWT Token
          doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
          clinicId: doctorInfo.CLINIC_ID,
          roleId: doctorInfo.MANDALI_ROLE
        }
}); 
      alert("Doctor added successfully!");
      navigate("/doctorslist");
    } catch (error) {
      console.error("Error adding doctor:", error);
      alert("Failed to add doctor. Please try again.");
    }
  };

  return (
    <div className="custom-form-container">
    <h2 className="form-title">Add Doctor</h2>
    <form onSubmit={handleSubmit} className="custom-form">
      <div className="form-group">
        <label>Doctor Name</label>
        <input
          type="text"
          className="form-control input-rounded"
          name="MANDALI_FULL_NAME"
          value={formData.MANDALI_FULL_NAME}
          onChange={handleChange}
          required
        />
      </div>

      {/* <div className="form-group">
        <label>Clinic</label>
        <select
          className="form-control input-rounded"
          name="CLINIC_ID"
          value={formData.CLINIC_ID}
          onChange={handleChange}
          required
        >
          <option value="">Select Clinic</option>
          {clinics.map((clinic) => (
            <option key={clinic.CLINIC_ID} value={clinic.CLINIC_ID}>
              {clinic.CLINIC_NAME}
            </option>
          ))}
        </select>
      </div>
 */}

<div className="form-group">
  <label>Clinics</label>
  <select
    className="form-control input-rounded"
    name="CLINIC_IDS"
    value={formData.CLINIC_IDS}
    onChange={(e) => {
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, CLINIC_IDS: selectedOptions });
    }}
    multiple
    required
  >
    {clinics.map((clinic) => (
      <option key={clinic.CLINIC_ID} value={clinic.CLINIC_ID}>
        {clinic.CLINIC_NAME}
      </option>
    ))}
  </select>
</div>


      <div className="form-group">
        <label>Mobile No</label>
        <input
          type="text"
          className="form-control input-rounded"
          name="MANDALI_MOB_NO"
          value={formData.MANDALI_MOB_NO}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label>Password</label>
        <div className="password-field">
          <input
            type={showPassword ? "text" : "password"}
            className="form-control input-rounded"
            name="MANDALI_PASSWORD"
            value={formData.MANDALI_PASSWORD}
            onChange={handleChange}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁
          </span>
        </div>
      </div>

      <div className="form-group">
        <label>Confirm Password</label>
        <div className="password-field">
          <input
            type={showConfirm ? "text" : "password"}
            className="form-control input-rounded"
            name="CONFIRM_PASSWORD"
            value={formData.CONFIRM_PASSWORD}
            onChange={handleChange}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowConfirm(!showConfirm)}
          >
            👁
          </span>
        </div>
      </div>

      <div className="button-group">
        <button type="button" className="btn cancel-btn" onClick={() => navigate("/doctorslist")}>
          Cancel
        </button>
        <button type="submit" className="btn submit-btn">
          Add Doctor
        </button>
      </div>
    </form>
  </div>
);
};

export default AddDoctor;